<template>
  <TableResponsiveContainer class="DealBillTable">
    <table>
      <thead>
        <tr>
          <th>{{ $t('billTableHeadLabelItem') }}</th>
          <th>{{ $t('billTableHeadLabelEnergyUsage') }} (kWh)</th>
          <th>{{ $t('billTableHeadLabelUnitPrice') }} (c&euro;/kWh)</th>
          <th>{{ $t('billTableHeadLabelTotal') }} (&euro;)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ $t('billTableSideLabelActiveHT') }}</td>
          <td>
            {{ deal.calculatedData.activeHTUsage | formatNumber }}
          </td>
          <td>
            {{ deal.active_energy_vt | formatNumber }}
          </td>
          <td>
            {{ deal.calculatedData.activeHTPrice | formatNumber }}
          </td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelActiveLT') }}</td>
          <td>{{ deal.calculatedData.activeLTUsage | formatNumber }}</td>
          <td>{{ deal.active_energy_mt | formatNumber }}</td>
          <td>{{ deal.calculatedData.activeLTPrice | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelNetworkCapacity') }}</td>
          <td>
            {{ deal.calculatedData.activeHTUsage
            + deal.calculatedData.activeLTUsage | formatNumber }}
          </td>
          <td>{{ deal.network_capacity | formatNumber }}</td>
          <td>{{ deal.calculatedData.networkCapacity | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelLossHT') }}</td>
          <td>
            {{ deal.calculatedData.activeHTUsage | formatNumber }}
          </td>
          <td>{{ deal.loss_vt | formatNumber }}</td>
          <td>{{ deal.calculatedData.lossHT | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelLossLT') }}</td>
          <td>
            {{ deal.calculatedData.activeLTUsage | formatNumber }}
          </td>
          <td>{{ deal.loss_mt | formatNumber }}</td>
          <td>{{ deal.calculatedData.lossLT | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelFixedNetworkCapacity') }}</td>
          <td>{{ 1 | formatNumber }}</td>
          <td>{{ deal.fixed_network_capacity | formatNumber }}</td>
          <td>{{ deal.calculatedData.fixedNetworkCapacity | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelOperator') }}</td>
          <td>
            {{ deal.calculatedData.activeHTUsage
            + deal.calculatedData.activeLTUsage | formatNumber }}
          </td>
          <td>{{ deal.operator | formatNumber }}</td>
          <td>{{ deal.calculatedData.operator | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelOIE') }}</td>
          <td>
            {{ deal.calculatedData.activeHTUsage
            + deal.calculatedData.activeLTUsage | formatNumber }}
          </td>
          <td>{{ deal.oie }}</td>
          <td>{{ deal.calculatedData.oie | formatNumber }}</td>
        </tr>
      </tbody>

      <div class="DealBill__bodySeparator"/>

      <tbody>
        <tr>
          <td>{{ $t('billTableSideLabelPriceWithoutVAT') }}</td>
          <td/>
          <td/>
          <td>{{ deal.calculatedData.neto - deal.calculatedData.vat | formatNumber }}</td>
        </tr>

        <tr>
          <td>{{ $t('billTableSideLabelVAT') }} (21%)</td>
          <td/>
          <td/>
          <td>{{ deal.calculatedData.vat | formatNumber }}</td>
        </tr>
        <tr>
          <td>{{ $t('billTableSideLabelNeto') }}</td>
          <td/>
          <td/>
          <td>{{ deal.calculatedData.neto | formatNumber }}</td>
        </tr>
        <tr>
          <td class="total">{{ $t('billTableSideLabelTotal') }}</td>
          <td/>
          <td/>
          <td/>
        </tr>
      </tbody>
    </table>
  </TableResponsiveContainer>
</template>

<script>
import TableResponsiveContainer from '@/components/table/ResponsiveContainer.vue';

export default {
  name: 'DealBillTable',
  components: {
    TableResponsiveContainer,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  created() {
    console.log(this.deal);
  },
};
</script>

<style scoped lang="scss">
.DealBillTable table {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  &:not(:last-child) {
    margin-bottom: 25px;
  }
}
.DealBillTable table thead {
  background-color: $color--primary;

  th {
    padding: 6px 12px;
    color: #fff;
    @include roboto400;
    font-size: 14px;
    text-align: left;

    & + th {
      text-align: right;
    }
  }
}
.DealBillTable table td {
  color: #000;
  color: rgba(0,0,0,0.7);
  font-size: 14px;
  width: 25%;
  padding: 6px 12px;

  &:first-child {
    color: rgba(0,0,0,0.8);
    @include roboto400;
  }
  & + td {
    text-align: right;
  }
  &.label--total {
    font-size: 16px;
    color: $color--primary;
  }
  &.totalPrice {
    font-size: 16px;
    color: $color--primary;
    @include roboto500;
  }
}
.DealBill__bodySeparator {
  height: 15px;
  background-color: transparent;
}
.DealBillTable__sectionTitle {
  th {
    padding-top: 12px;
    padding-bottom: 4px;
  }

  p {
    margin: 0;
    @include roboto400;
    font-size: 14px;
  }
}
</style>
